export default [
  {
    id: `contour-funnels-country`,
    expectedGlobalMessage: `For funnel, Signup -> Viewed Report, users where Country = Vietnam or Mexico convert 8-20% worse and users where Country = Israel or Sweden convert 7-10% better than your overall user base.`,
    expectedMessages: [
      `Users where Country = Israel have a 91.70% conversion rate in your funnel. This is 7% higher than your overall conversion rate of 85.42%.`,
      `Users where Country = Vietnam have a 67.91% conversion rate in your funnel. This is 20% lower than your overall conversion rate of 85.42%.`,
      `Users where Country = Sweden have a 94.01% conversion rate in your funnel. This is 10% higher than your overall conversion rate of 85.42%.`,
      `Users where Country = Mexico have a 78.60% conversion rate in your funnel. This is 8% lower than your overall conversion rate of 85.42%.`,
    ],
    alert: {
      alertId: `contour-funnels-basic-id`,
      detectionReason: `PROJECT`,
      isAlertOwner: true,
      ingestedAtMs: `1503707267000`,
      contour: {
        baseConversionRate: 0.8542,
        property: `mp_country_code`,
        propertyType: `STRING`,
        reportId: 2083398,
        funnelsDetails: {
          funnelName: `Signup -> Viewed Report`,
          bookmarkId: 1745325,
        },
        dateRange: {
          from: `2017-05-28`,
          to: `2017-08-25`,
        },
        contourDetails: [
          {
            contourDetailId: `funnels-country-segment1`,
            stringValue: `IL`,
            conversionRate: 0.917,
            score: 3.5,
            pValue: 0.95,
            sentFeedbackAtMs: `1503800050000`,
          },
          {
            contourDetailId: `funnels-country-segment2`,
            stringValue: `VN`,
            conversionRate: 0.6791,
            score: 2.5,
            pValue: 0.95,
          },
          {
            contourDetailId: `funnels-country-segment3`,
            stringValue: `SE`,
            conversionRate: 0.9401,
            score: 1.5,
            pValue: 0.95,
          },
          {
            contourDetailId: `funnels-country-segment4`,
            stringValue: `MX`,
            conversionRate: 0.786,
            score: 0.5,
            pValue: 0.95,
          },
        ],
      },
    },
  },
  {
    id: `contour-retention-country`,
    expectedGlobalMessage: `For Signup to Viewed report retention, users where Browser = Mobile Safari retain 68% worse and users where Browser = Safari, Chrome, or Firefox retain 15-59% better than your overall user base.`,
    expectedMessages: [
      `Users where Browser = Mobile Safari have a 6.45% retention rate for 1 week retention. This is 68% lower than your overall retention rate of 20.00%.`,
      `Users where Browser = Safari have a 31.79% retention rate for 1 week retention. This is 59% higher than your overall retention rate of 20.00%.`,
      `Users where Browser = Chrome have a 29.75% retention rate for 1 week retention. This is 49% higher than your overall retention rate of 20.00%.`,
      `Users where Browser = Firefox have a 22.99% retention rate for 1 week retention. This is 15% higher than your overall retention rate of 20.00%.`,
    ],
    alert: {
      alertId: `contour-retention-basic-id`,
      detectionReason: `PROJECT`,
      isAlertOwner: true,
      ingestedAtMs: `1503707300000`,
      contour: {
        baseConversionRate: 0.2,
        property: `$browser`,
        propertyType: `STRING`,
        reportId: 1234,
        retentionDetails: {
          interval: 1,
          bornEvent: `$signup`,
          bornEventDisplayName: `Signup`,
          event: `Viewed report`,
          eventDisplayName: `Viewed report`,
          timeUnit: `WEEK`,
        },
        dateRange: {
          from: `2017-07-01`,
          to: `2017-08-15`,
        },
        contourDetails: [
          {
            contourDetailId: `retention-browser-segment1`,
            stringValue: `Safari`,
            conversionRate: 0.3179,
            score: 4.4,
            pValue: 0.95,
          },
          {
            contourDetailId: `retention-browser-segment2`,
            stringValue: `Mobile Safari`,
            conversionRate: 0.0645,
            score: 5.5,
            pValue: 0.95,
          },
          {
            contourDetailId: `retention-browser-segment3`,
            stringValue: `Firefox`,
            conversionRate: 0.2299,
            score: 1.1,
            pValue: 0.95,
          },
          {
            contourDetailId: `retention-browser-segment4`,
            stringValue: `Chrome`,
            conversionRate: 0.2975,
            score: 2.2,
            pValue: 0.95,
          },
        ],
      },
    },
  },
];
